import { FC } from 'react';
import { ACWR_ZONES } from '@leopart/calc';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
  ReferenceArea, ReferenceLine,
} from 'recharts';
import { ChartEmptyState } from '../../AthleteInjuryCharts/charts/_shared/ChartEmptyState';
import { ITeamAcwrMetric } from '../../../../models/injury';
import {
  chartAxisTick,
  chartGridProps,
  chartTooltipContentStyle,
  chartTooltipItemStyle,
  chartTooltipLabelStyle,
} from '../../../../shared/charts/chartTheme';

interface Props {
  data: ITeamAcwrMetric | null;
}

export const TeamAcwrChart: FC<Props> = ({ data }) => {
  if (!data?.series?.length) return <ChartEmptyState />;

  const chartData = data.series.map((s) => ({
    date: s.date.slice(5),
    acwr: s.acwr,
  }));

  return (
    <ResponsiveContainer width="100%" height={200}>
      <LineChart data={chartData} margin={{ top: 4, right: 8, left: -20, bottom: 0 }}>
        {/* Bande da ACWR_ZONES (@leopart/calc): <0.8 NON è "verde" — è
            detraining (era colorato come ottimale: bug censimento R2).
            Token -bg già "soft": niente fillOpacity aggiuntiva. */}
        <ReferenceArea y1={0} y2={ACWR_ZONES.okMin} fill="var(--c-error-bg)" />
        <ReferenceArea y1={ACWR_ZONES.okMin} y2={ACWR_ZONES.warnMax} fill="var(--c-success-bg)" />
        <ReferenceArea y1={ACWR_ZONES.warnMax} y2={3} fill="var(--c-warning-bg)" />
        <CartesianGrid {...chartGridProps} />
        <XAxis dataKey="date" tick={chartAxisTick} interval="preserveStartEnd" />
        <YAxis tick={chartAxisTick} domain={[0, 'auto']} />
        <Tooltip
          contentStyle={chartTooltipContentStyle}
          labelStyle={chartTooltipLabelStyle}
          itemStyle={chartTooltipItemStyle}
          formatter={(v) => [Number(v).toFixed(2), 'ACWR medio']}
        />
        {(data.injuryMarkers ?? []).map((m, i) => (
          <ReferenceLine key={i} x={m.date?.slice(5)} stroke="var(--c-error)" strokeDasharray="4 2" />
        ))}
        <Line
          type="monotone"
          dataKey="acwr"
          stroke="var(--c-text-0)"
          strokeWidth={2}
          dot={false}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};
